import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSimpleCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "min-w-0 w-full" },
    [
      _c("div", { staticClass: "display-1" }, [
        _vm._v(_vm._s(_vm.$t("menu.dp.up_table_details"))),
      ]),
      _c(
        VCard,
        { staticClass: "mt-2" },
        [
          _c(VDataTable, {
            staticClass: "table-inca",
            attrs: {
              headers: _vm.headers,
              items: _vm.select_profile_user_tables,
              "item-class": _vm.rowClassFlag,
              "items-per-page": _vm.pagination.limit,
              page: _vm.pagination.current,
              "hide-default-footer": "",
            },
            on: {
              pagination: function ($event) {
                _vm.pagination.total = $event.itemsLength
              },
              "update:page": function ($event) {
                return _vm.$set(_vm.pagination, "current", $event)
              },
            },
            scopedSlots: _vm._u([
              {
                key: "item.load_date",
                fn: function (ref) {
                  var item = ref.item
                  return [
                    _c("span", [
                      _vm._v(
                        _vm._s(new Date(item.load_date).toLocaleString("en-GB"))
                      ),
                    ]),
                  ]
                },
              },
              {
                key: "item.actions",
                fn: function (data) {
                  return [
                    _c(
                      VTooltip,
                      {
                        attrs: { bottom: "" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "activator",
                              fn: function (ref) {
                                var on = ref.on
                                var attrs = ref.attrs
                                return [
                                  _c(
                                    VBtn,
                                    _vm._g(
                                      _vm._b(
                                        {
                                          staticClass: "btn-icon-inca",
                                          attrs: { icon: "", small: "" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.showModal(data, "view")
                                            },
                                          },
                                        },
                                        "v-btn",
                                        attrs,
                                        false
                                      ),
                                      on
                                    ),
                                    [_c(VIcon, [_vm._v("icon-view")])],
                                    1
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          true
                        ),
                      },
                      [_c("span", [_vm._v(_vm._s(_vm.$t("crud.View")))])]
                    ),
                    _c(
                      VTooltip,
                      {
                        attrs: { bottom: "" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "activator",
                              fn: function (ref) {
                                var on = ref.on
                                var attrs = ref.attrs
                                return [
                                  _c(
                                    VBtn,
                                    _vm._g(
                                      _vm._b(
                                        {
                                          staticClass: "btn-icon-inca",
                                          attrs: { icon: "", small: "" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.showModal(data, "edit")
                                            },
                                          },
                                        },
                                        "v-btn",
                                        attrs,
                                        false
                                      ),
                                      on
                                    ),
                                    [_c(VIcon, [_vm._v("icon-edit")])],
                                    1
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          true
                        ),
                      },
                      [_c("span", [_vm._v("Edit")])]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c("pagination-vue", { attrs: { pagination: _vm.pagination } }),
      _c(
        "DialogsComponent",
        { ref: "dialog", attrs: { title: _vm.modalTitle, width: 1800 } },
        [
          _c(
            "template",
            { slot: "body" },
            [
              _c(
                VForm,
                { ref: "form" },
                [
                  _c(
                    VRow,
                    { attrs: { dense: "" } },
                    [
                      _c(
                        VCol,
                        { attrs: { sm: "12", lg: "6" } },
                        [
                          _c(
                            VRow,
                            { attrs: { dense: "", justify: "center" } },
                            [
                              _c(
                                VCol,
                                { staticClass: "col-md-3" },
                                [
                                  _c(
                                    VSubheader,
                                    { staticClass: "font-weight-bold p-0" },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("tablas.area")) + " :"
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _c(
                                VCol,
                                { staticClass: "col-md-9" },
                                [
                                  _c(VSelect, {
                                    attrs: {
                                      outlined: !_vm.readonly,
                                      readonly: _vm.readonly,
                                      filled: _vm.readonly,
                                      dense: "",
                                      items: _vm.select_areas,
                                      value: _vm.record.area_id,
                                      rules: [
                                        function (v) {
                                          return !!v || "This field is required"
                                        },
                                      ],
                                      "hide-details": "auto",
                                    },
                                    on: { change: _vm.changeArea },
                                    model: {
                                      value: _vm.record.area_id,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.record, "area_id", $$v)
                                      },
                                      expression: "record.area_id",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        VCol,
                        { attrs: { sm: "12", lg: "6" } },
                        [
                          _c(
                            VRow,
                            { attrs: { dense: "", justify: "center" } },
                            [
                              _c(
                                VCol,
                                { staticClass: "col-md-3" },
                                [
                                  _c(
                                    VSubheader,
                                    { staticClass: "font-weight-bold p-0" },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("tablas.profile")) + " :"
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _c(
                                VCol,
                                { staticClass: "col-md-9" },
                                [
                                  _c(VSelect, {
                                    attrs: {
                                      outlined: !_vm.readonly,
                                      readonly: _vm.readonly,
                                      filled: _vm.readonly,
                                      dense: "",
                                      items: _vm.profileFiltered,
                                      value: _vm.record.userprofile_id,
                                      rules: [
                                        function (v) {
                                          return !!v || "This field is required"
                                        },
                                      ],
                                      "hide-details": "auto",
                                    },
                                    model: {
                                      value: _vm.record.userprofile_id,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.record,
                                          "userprofile_id",
                                          $$v
                                        )
                                      },
                                      expression: "record.userprofile_id",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    VRow,
                    { attrs: { dense: "" } },
                    [
                      _c(
                        VCol,
                        { attrs: { sm: "12", lg: "12" } },
                        [
                          _c(
                            "actions-component",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: !_vm.readonly,
                                  expression: "!readonly",
                                },
                              ],
                            },
                            [
                              _c(
                                "template",
                                { slot: "actions" },
                                [
                                  _c(
                                    VBtn,
                                    {
                                      staticClass: "ml-1 btn-inca-secondary",
                                      attrs: { dense: "", outlined: "" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.addItem()
                                        },
                                      },
                                    },
                                    [
                                      _c(VIcon, { attrs: { small: "" } }, [
                                        _vm._v("icon-add"),
                                      ]),
                                      _vm._v(_vm._s(_vm.$t("btns.add_item"))),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            2
                          ),
                          _c(
                            VRow,
                            {
                              staticClass: "mt-2",
                              attrs: { "no-gutters": "", align: "center" },
                            },
                            [
                              _c(
                                VChip,
                                {
                                  staticClass: "mr-2",
                                  attrs: {
                                    small: "",
                                    color: "success",
                                    outlined: _vm.showOnlyPending,
                                  },
                                  on: {
                                    click: function ($event) {
                                      _vm.showOnlyPending = false
                                    },
                                  },
                                },
                                [
                                  _c(
                                    VIcon,
                                    { attrs: { small: "", left: "" } },
                                    [_vm._v("mdi-check-circle")]
                                  ),
                                  _vm._v(
                                    _vm._s(_vm.validatedCount) + " validadas"
                                  ),
                                ],
                                1
                              ),
                              _c(
                                VChip,
                                {
                                  attrs: {
                                    small: "",
                                    color: "warning",
                                    outlined: !_vm.showOnlyPending,
                                  },
                                  on: {
                                    click: function ($event) {
                                      _vm.showOnlyPending = !_vm.showOnlyPending
                                    },
                                  },
                                },
                                [
                                  _c(
                                    VIcon,
                                    { attrs: { small: "", left: "" } },
                                    [_vm._v("mdi-alert-outline")]
                                  ),
                                  _vm._v(
                                    _vm._s(_vm.pendingCount) + " pendientes"
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(VTextField, {
                            staticClass: "mt-2",
                            attrs: {
                              "append-icon": "mdi-magnify",
                              label: "Buscar tabla...",
                              "single-line": "",
                              "hide-details": "",
                              outlined: "",
                              dense: "",
                            },
                            model: {
                              value: _vm.search,
                              callback: function ($$v) {
                                _vm.search = $$v
                              },
                              expression: "search",
                            },
                          }),
                          _c(VDataTable, {
                            key: _vm.key_table_detail,
                            staticClass: "table-inca table-inca-p-0",
                            attrs: {
                              headers: _vm.filteredHeaders,
                              "hide-default-footer": "",
                              items: _vm.filteredRecordDetails,
                              "item-class": _vm.rowClassFlag,
                              "items-per-page": _vm.pagination2.limit,
                              page: _vm.pagination2.current,
                            },
                            on: {
                              pagination: function ($event) {
                                _vm.pagination2.total = $event.itemsLength
                              },
                              "update:page": function ($event) {
                                return _vm.$set(
                                  _vm.pagination2,
                                  "current",
                                  $event
                                )
                              },
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "item.project_name",
                                fn: function (data) {
                                  return [
                                    data.item.source == "synapse"
                                      ? _c(VTextField, {
                                          attrs: {
                                            outlined: "",
                                            dense: "",
                                            required: "",
                                            disabled: _vm.readonly,
                                            size: "sm",
                                            change: _vm.cambiarDatosTabla(
                                              data.index,
                                              "P"
                                            ),
                                            "hide-details": "auto",
                                          },
                                          model: {
                                            value: data.item.project_name,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                data.item,
                                                "project_name",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "data.item.project_name",
                                          },
                                        })
                                      : _c(VSelect, {
                                          attrs: {
                                            items: _vm.projectListDict,
                                            outlined: "",
                                            dense: "",
                                            required: "",
                                            disabled: _vm.readonly,
                                            size: "sm",
                                            change: _vm.cambiarDatosTabla(
                                              data.index,
                                              "P"
                                            ),
                                            "hide-details": "auto",
                                          },
                                          model: {
                                            value: data.item.project_name,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                data.item,
                                                "project_name",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "data.item.project_name",
                                          },
                                        }),
                                  ]
                                },
                              },
                              {
                                key: "item.source",
                                fn: function (data) {
                                  return [
                                    _c(VSelect, {
                                      attrs: {
                                        items: _vm.source_list,
                                        required: "",
                                        outlined: "",
                                        dense: "",
                                        readonly: _vm.readonly,
                                        size: "sm",
                                        "hide-details": "auto",
                                      },
                                      model: {
                                        value: data.item.source,
                                        callback: function ($$v) {
                                          _vm.$set(data.item, "source", $$v)
                                        },
                                        expression: "data.item.source",
                                      },
                                    }),
                                  ]
                                },
                              },
                              {
                                key: "item.dataset_name",
                                fn: function (data) {
                                  return [
                                    _c(VTextField, {
                                      attrs: {
                                        required: "",
                                        outlined: "",
                                        dense: "",
                                        readonly: _vm.readonly,
                                        size: "sm",
                                        change: _vm.cambiarDatosTabla(
                                          data.index,
                                          "D"
                                        ),
                                        "hide-details": "auto",
                                      },
                                      model: {
                                        value: data.item.dataset_name,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            data.item,
                                            "dataset_name",
                                            typeof $$v === "string"
                                              ? $$v.trim()
                                              : $$v
                                          )
                                        },
                                        expression: "data.item.dataset_name",
                                      },
                                    }),
                                  ]
                                },
                              },
                              {
                                key: "item.default_accesstime_months",
                                fn: function (data) {
                                  return [
                                    _c(VTextField, {
                                      attrs: {
                                        outlined: "",
                                        dense: "",
                                        required: "",
                                        readonly: _vm.readonly,
                                        size: "sm",
                                        type: "number",
                                        "hide-details": "auto",
                                      },
                                      model: {
                                        value:
                                          data.item.default_accesstime_months,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            data.item,
                                            "default_accesstime_months",
                                            _vm._n($$v)
                                          )
                                        },
                                        expression:
                                          "data.item.default_accesstime_months",
                                      },
                                    }),
                                  ]
                                },
                              },
                              {
                                key: "item.accesstype_id",
                                fn: function (ref) {
                                  var item = ref.item
                                  return [
                                    _c(VSelect, {
                                      attrs: {
                                        items: _vm.access_type_options,
                                        outlined: "",
                                        dense: "",
                                        required: "",
                                        disabled: _vm.readonly,
                                        "hide-details": "auto",
                                      },
                                      model: {
                                        value: item.accesstype_id,
                                        callback: function ($$v) {
                                          _vm.$set(item, "accesstype_id", $$v)
                                        },
                                        expression: "item.accesstype_id",
                                      },
                                    }),
                                  ]
                                },
                              },
                              {
                                key: "item.flag_active",
                                fn: function (ref) {
                                  var item = ref.item
                                  return [
                                    _c(VSimpleCheckbox, {
                                      attrs: {
                                        required: "",
                                        disabled: _vm.readonly,
                                        "hide-details": "auto",
                                      },
                                      model: {
                                        value: item.flag_active,
                                        callback: function ($$v) {
                                          _vm.$set(item, "flag_active", $$v)
                                        },
                                        expression: "item.flag_active",
                                      },
                                    }),
                                  ]
                                },
                              },
                              {
                                key: "item.actions",
                                fn: function (data) {
                                  return [
                                    _c(
                                      VTooltip,
                                      {
                                        attrs: { bottom: "" },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "activator",
                                              fn: function (ref) {
                                                var on = ref.on
                                                var attrs = ref.attrs
                                                return [
                                                  _c(
                                                    VBtn,
                                                    _vm._g(
                                                      _vm._b(
                                                        {
                                                          directives: [
                                                            {
                                                              name: "show",
                                                              rawName: "v-show",
                                                              value:
                                                                !_vm.readonly,
                                                              expression:
                                                                "!readonly",
                                                            },
                                                          ],
                                                          staticClass:
                                                            "btn-icon-inca",
                                                          attrs: {
                                                            icon: "",
                                                            small: "",
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.removeItem(
                                                                data.item
                                                              )
                                                            },
                                                          },
                                                        },
                                                        "v-btn",
                                                        attrs,
                                                        false
                                                      ),
                                                      on
                                                    ),
                                                    [
                                                      _c(VIcon, [
                                                        _vm._v("icon-delete"),
                                                      ]),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                      },
                                      [
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(_vm.$t("btns.remove_item"))
                                          ),
                                        ]),
                                      ]
                                    ),
                                  ]
                                },
                              },
                              {
                                key: "item.table_name",
                                fn: function (ref) {
                                  var item = ref.item
                                  var index = ref.index
                                  return [
                                    _c(
                                      "th",
                                      { staticStyle: { width: "240px" } },
                                      [
                                        _c(VTextField, {
                                          attrs: {
                                            outlined: "",
                                            required: "",
                                            dense: "",
                                            readonly: _vm.readonly,
                                            type: "text",
                                            size: "sm",
                                            change: _vm.cambiarDatosTabla(
                                              index,
                                              "T"
                                            ),
                                            "hide-details": "auto",
                                          },
                                          on: {
                                            keydown: function ($event) {
                                              if (
                                                !$event.type.indexOf("key") &&
                                                $event.keyCode !== 13
                                              ) {
                                                return null
                                              }
                                              $event.preventDefault()
                                              return _vm.enterValidateTable(
                                                $event,
                                                item,
                                                index
                                              )
                                            },
                                          },
                                          model: {
                                            value: item.table_name,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                item,
                                                "table_name",
                                                typeof $$v === "string"
                                                  ? $$v.trim()
                                                  : $$v
                                              )
                                            },
                                            expression: "item.table_name",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _c("th", [
                                      item.table_verified == true
                                        ? _c(
                                            "span",
                                            [
                                              _c(
                                                VIcon,
                                                {
                                                  attrs: {
                                                    small: "",
                                                    color: "green",
                                                  },
                                                },
                                                [_vm._v("icon-check")]
                                              ),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      item.table_verified == false
                                        ? _c(
                                            "span",
                                            {
                                              directives: [
                                                {
                                                  name: "b-popover",
                                                  rawName:
                                                    "v-b-popover.hover.left",
                                                  value: item.error,
                                                  expression: "item.error",
                                                  modifiers: {
                                                    hover: true,
                                                    left: true,
                                                  },
                                                },
                                              ],
                                              staticClass: "h6 pointer",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.validarTabla(
                                                    item,
                                                    index
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c(
                                                VIcon,
                                                {
                                                  attrs: {
                                                    small: "",
                                                    color: "orange",
                                                  },
                                                },
                                                [_vm._v("mdi-alert-outline")]
                                              ),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                    ]),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _c("pagination-vue", {
                            attrs: { pagination: _vm.pagination2 },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    VRow,
                    [
                      _c(
                        VCol,
                        { attrs: { cols: "12" } },
                        [
                          _c(
                            VAlert,
                            {
                              attrs: {
                                value: _vm.alert,
                                dismissible: "",
                                color: "danger",
                                transition: "slide-y-transition",
                              },
                              on: { input: _vm.dismissible_close },
                            },
                            [
                              _c("p", [_vm._v(_vm._s(_vm.dangerMessage))]),
                              _c(VProgressLinear, {
                                attrs: { value: _vm.dismissCountDown },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.loadingBulk
                ? _c(
                    VRow,
                    { attrs: { dense: "" } },
                    [
                      _c(
                        VCol,
                        { attrs: { cols: "12" } },
                        [
                          _c(VProgressLinear, {
                            attrs: { indeterminate: "", color: "primary" },
                          }),
                          _c(
                            VAlert,
                            {
                              staticClass: "mt-2",
                              attrs: { type: "info", dense: "", outlined: "" },
                            },
                            [_vm._v("Cargando archivo, por favor espere...")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          !_vm.readonly
            ? _c(
                "template",
                { slot: "btnsLeft" },
                [
                  _c(
                    VBtn,
                    {
                      staticClass: "mr-2",
                      attrs: { outlined: "", color: "primary" },
                      on: { click: _vm.downloadTemplate },
                    },
                    [
                      _c(VIcon, { attrs: { small: "" } }, [
                        _vm._v("mdi-cloud-download"),
                      ]),
                      _vm._v(
                        _vm._s(_vm.$t("botones.boton_descargar_template"))
                      ),
                    ],
                    1
                  ),
                  _c("input", {
                    ref: "btnBulkUpload",
                    staticStyle: { display: "none" },
                    attrs: { type: "file" },
                    on: { change: _vm.uploadFile },
                  }),
                  _c(
                    VBtn,
                    {
                      attrs: {
                        outlined: "",
                        color: "primary",
                        loading: _vm.loadingBulk,
                        disabled: _vm.loadingBulk,
                      },
                      on: { click: _vm.laucherBulkUpload },
                    },
                    [
                      _c(VIcon, { attrs: { small: "" } }, [
                        _vm._v("mdi-cloud-upload"),
                      ]),
                      _vm._v(_vm._s(_vm.$t("botones.boton_cargar_archivo"))),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          !_vm.readonly
            ? _c(
                "template",
                { slot: "btnsRight" },
                [
                  _c(
                    VBtn,
                    {
                      staticClass: "primary",
                      attrs: { color: "primary" },
                      on: { click: _vm.handleSubmit },
                    },
                    [
                      _c(VIcon, [_vm._v("icon-send")]),
                      _vm._v(_vm._s(_vm.$t("botones.boton_aceptar"))),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }